<div class="auth-wrapper auth-v2">
    <app-language-selector></app-language-selector>
    <div class="auth-inner max-width row m-0">
        <! -- Left side -->
        <div class="d-flex align-items-center p-5 l-side">
            <div
                    class="w-100 d-lg-flex align-items-center justify-content-center px-5"
            >
                <img
                        class="img-fluid"
                        [src]="isMobile() | authHeroImage"
                        alt="Login V2"
                />
            </div>
        </div>

        <! -- Right side -->

        <div class="d-flex align-items-center auth-bg r-side">
            <div class="mx-auto login-form">
                <div class="company-logo" *ngIf="logo">
                    <img src="{{logo}}" alt="">
                </div>

                <h2 class="card-title mb-1">
                    {{ 'COMPANY_LOGIN.FORM_HEADER' | translate }} 👋
                </h2>
                <p class="card-text mb-2" *ngIf="!isSuccess">{{ 'COMPANY_SIGNUP.FORM_SUBHEADER' | translate }}</p>

                <form  class="auth-login-form mt-2"  [formGroup]="companySignUpForm" (ngSubmit)="signUp()" *ngIf="!isSuccess">
                    <div class="form-group">
                        <label class="form-label">{{ 'COMPANY_SIGNUP.CNP_LABEL' | translate }}</label>
                        <input
                                type="number"
                                formControlName="cnp"
                                class="form-control"
                                placeholder="1231230123456"
                                aria-describedby="cnp"
                                tabindex="2"
                                autofocus
                                #cnp
                                [readOnly]="cnpDisabled === true"
                                [ngClass]="{'is-invalid': f?.cnp.errors && (f?.cnp.dirty || f?.cnp.touched)}"
                        />
                        <div *ngIf="f?.cnp.errors &&(f?.cnp.dirty || f?.cnp.touched)" class="invalid-feedback">
                            <div *ngIf="f?.cnp.errors.required">
                                {{ 'SIGNUP.CNP_REQUIRED' | translate }}
                            </div>
                            <div *ngIf="f?.cnp.errors.pattern">
                                {{ 'SIGNUP.CNP_WRONG' | translate }}
                            </div>
                        </div>

                    </div>

                    <div class="form-group" *ngIf="emailFieldVisible">
                        <label class="form-label">{{ 'LOGIN.EMAIL_LABEL' | translate }}</label>
                        <input tabindex="1" id="login-input" formControlName="email" class="form-control" type="email"
                                [placeholder]="'account@mail.com'"
                                [ngClass]="{'is-invalid': f?.email.errors && (f?.email.dirty || f?.email.touched)}"
                        />
                        <div *ngIf="f?.email.errors &&(f?.email.dirty || f?.email.touched)" class="invalid-feedback">
                            <div *ngIf="f?.email.errors.required">
                                {{ 'LOGIN.EMAIL_REQUIRED' | translate }}
                            </div>
                            <div *ngIf="f?.email.errors.pattern">
                                {{ 'LOGIN.EMAIL_WRONG' | translate }}
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <button type="submit" [disabled]="companySignUpForm.invalid"
                                class="btn btn-primary btn-block" tabindex="4" rippleEffect>
                            {{ 'COMPANY_SIGNUP.NEXT_BUTTON' | translate }}
                        </button>
                    </div>
                </form>

                <div *ngIf="isSuccess">
                    {{ 'COMPANY_SIGNUP.SUCCESS' | translate}}
                </div>
            </div>
        </div>
    </div>
</div>
